import styled from 'styled-components';
import { FormGroup } from '../style';

export const SelectFormGroup = styled(FormGroup)`
  position: relative;
`;

export const InfoLinkText = styled.span`
  font-size: 12px;
`;
